import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';

import { ButtonComponent } from '../../../buttons/button.component';
import { AppShellService } from '../../services/app-shell.service';

@Component({
  selector: 'mop-navbar',
  imports: [ButtonComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  private readonly appShellService = inject(AppShellService);

  appName = input('');
  logoClicked = output();

  toggleSideNav() {
    this.appShellService.toggleSideNav();
  }

  protected logoClick() {
    this.logoClicked.emit();
  }
}
